import { CustomTooltip } from '@/components/custom-tooltip';
import './comp-rate-tooltip.scss';
import { usePropertyContext } from 'context/propertyContext';
import { formatDateWithGivenFormatter } from 'features/dates/date-helpers';
import { labels } from 'locales/en.label';
import { twoDecimalRateFormatter } from 'pages/MyView/tableCustomCellRender';
import type { CompRateObj } from 'pages/MyView/useDashboardController';

const tooltipLabels = labels.comp_rates.tooltip;

interface CompRateTooltipProps {
	data: CompRateObj;
	children: React.ReactElement<any, any> & React.ReactNode;
}

const format = (value: string) =>
	formatDateWithGivenFormatter(value, 'M/DD/YY');

export const CompRateTooltip = ({ data, children }: CompRateTooltipProps) => {
	const { currencySymbol } = usePropertyContext();

	return (
		<CustomTooltip
			placement='bottom'
			backgroundColor='tw-bg-white'
			arrowColor='tw-fill-primary'
			arrow
			borderColor='tw-border-primary'
			content={
				<div className='comp-rate-tooltip'>
					<div className='row'>
						<span className='label'>{tooltipLabels.stay_date}</span>
						<span>{format(data.arrivalDate)}</span>
					</div>
					<div className='row'>
						<span className='label'>{tooltipLabels.shop_date}</span>
						<span>{format(data.extractDateTime)}</span>
					</div>
					<div className='row'>
						<span className='label'>{tooltipLabels.rate}</span>
						<span>
							{currencySymbol}
							{twoDecimalRateFormatter(data.value ?? 0)}
						</span>
					</div>
					<div className='row'>
						<span className='label'>{tooltipLabels.room_name}</span>
						<span>{data.roomName}</span>
					</div>
					<div className='row'>
						<span className='label'>{tooltipLabels.los}</span>
						<span>{data.los}</span>
					</div>
					<div className='row'>
						<span className='label'>{tooltipLabels.best_flex}</span>
						<span>{data.best_flex ? 'True' : 'False'}</span>
					</div>
					<div className='row'>
						<span className='label'>{tooltipLabels.rate_changes}</span>
					</div>
					{data.changes?.map(({ day, value }) => (
						<div className='row' key={day}>
							<span className='label sub'>{tooltipLabels.days_ago(day)}</span>
							<span>
								{currencySymbol}
								{twoDecimalRateFormatter(value)}
							</span>
						</div>
					))}
				</div>
			}
		>
			{children}
		</CustomTooltip>
	);
};
